module.exports = __webpack_public_path__ + "img/white-logo.5fb404d8.png";